import React from "react";
import LogoHeader from "../components/Header/LogoHeader";
import Footer from "../components/Footer/Footer";

const KnowledgeHubLayout = ({ children, sidebar, topContent }) => {
  return (
    <div className="relative min-h-screen bg-pl-bg">
      <div className="fixed w-full bg-pl-bg border-b border-pl-border z-[90]" />
      <LogoHeader />

      <main className="mb-40 w-full pt-[104px]">
        <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 md:px-10">
          {topContent}

          <div
            className={
              sidebar
                ? "grid w-full gap-10 lg:grid-cols-[minmax(0,1fr)_240px]"
                : "w-full"
            }
          >
            <div className="min-w-0 w-full">
              {children}
            </div>

            {sidebar && (
              <aside className="hidden min-w-0 lg:block">
                {sidebar}
              </aside>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default KnowledgeHubLayout;
